export default "__VITE_ASSET__Cplh29o3__"